const state = {
    data: []
}

const mutations = {
    save(state, data) {
        state.data = data
    },
}

export default {
    namespaced: true,
    state,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/kategori.js